{
	"cardHeader": "Πρόσβαση στις δηλώσεις σας",
	"supplierTitle": "Είστε ο προμηθευτής μιας δήλωσης evoZero;",
	"supplierDescription": "Διαχειριστείτε τις δηλώσεις για τα υλικά evoZero σας.",
	"loginButton": "Σύνδεση"
}
